import { use } from 'react'
import { FlowerCollectionProduct } from '@/api-client/data-contracts'
import background from './images/background.jpg'

const VASES = [
  { match: /^天然石のような美しさ/, name: '天然石のような花器', description: 'モダンな雰囲気で飾りたいならこちら' },
  { match: /ドロップベース/, name: 'ドロップベース', description: 'パフェグラスのような形が特徴の人気花器' },
  { match: /Renoir.+グリーン/, name: 'Renoir', description: 'アンティーク調のルックスがバラとの相性抜群' },
  { match: /Calore.+ホワイト/, name: 'Calore（ホワイト）', description: 'ぽってり丸みのある形がアンティークのピッチャーのよう' },
  { match: /Calore.+ブラック/, name: 'Calore（ブラック）', description: 'ぽってり丸みのある形がアンティークのピッチャーのよう' },
]

type Props = {
  inBulkPurchasables: Promise<FlowerCollectionProduct[]>
}

const yen = (amount: number) => `${amount.toLocaleString('ja-JP')}円`

export const VasesSection: React.FC<Props> = ({ inBulkPurchasables }) => {
  const products = use(inBulkPurchasables)

  const vases = VASES.map((vase) => {
    const product = products.find((p) => p.attributes.name.match(vase.match))

    if (product) {
      return {
        ...vase,
        image: product.attributes.image_medium_url,
        originalPrice: yen(product.attributes.original_price),
        price: yen(product.attributes.bulk_discounted_price),
        outOfStock: !product.attributes.on_sale,
      }
    } else {
      return undefined
    }
  }).filter((vase) => vase !== undefined)

  return (
    <section className="relative py-14 flex flex-col gap-8 overflow-hidden">
      <div className="absolute inset-0 w-full h-full opacity-20 pointer-events-none bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url(${background})` }} />
      <div className="relative flex flex-col gap-3 items-center px-6 text-center">
        <p className="text-[16px] text-accent font-dm-serif font-medium">Flower Vase</p>
        <h2 className="text-[22px] font-bold text-black leading-normal">
          バラにぴったりの花器も
          <br />
          ご用意しました
        </h2>
        <p className="text-[14px] leading-[1.6] text-black">
          お手持ちの花器がなくても大丈夫。
          <br />
          置くだけで絵になる、フローリストいち押しの
          <br />
          花器を5種類ご用意しました。
        </p>
        <p className="rounded-md px-3 text-[13px] font-bold text-accent" style={{
          border: "1px solid rgba(228, 99, 39, 0.30)",
          background: "linear-gradient(0deg, rgba(228, 99, 39, 0.10) 0%, rgba(228, 99, 39, 0.10) 100%), rgba(255, 255, 255, 0.80)",
        }}>
          お申し込み時に一緒に買うと20%OFF
        </p>
      </div>

      <div className="relative flex gap-3 items-stretch justify-start md:justify-center lg:justify-start overflow-x-auto px-6 scrollbar-none">
        {vases.map((vase) => (
          <article
            key={vase.name}
            className={`bg-white rounded-2xl overflow-hidden shrink-0 w-46 shadow-[0_8px_16px_rgba(197,197,197,0.05)] ${'outOfStock' in vase && vase.outOfStock ? 'opacity-70' : ''}`}
          >
            <div className="relative">
              <img src={vase.image} alt={vase.name} className="w-full aspect-square object-cover" />
              {'outOfStock' in vase && vase.outOfStock && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="bg-black/70 text-white text-[11px] font-medium px-3 py-1 rounded-full">在庫切れ</span>
                </div>
              )}
            </div>
            <div className="p-3 flex flex-col gap-1.5">
              <h3 className="text-[14px] font-bold text-black truncate">{vase.name}</h3>
              <p className="text-[13px] text-dark-gray">{vase.description}</p>
              <p className="flex items-center gap-2">
                <span className="text-[12px] text-dark-gray line-through">{vase.originalPrice}</span>
                <span className="text-[14px] font-bold text-accent">{vase.price}</span>
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
